import ilComponent from './RefLink'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}

